{
  "static-content-online-booking-benefit": {
    "buttons": {},
    "text": {
      "title-1": "Online buchen, ",
      "title-2": "Vorteile genießen!",
      "description": "Erleben Sie den ultimativen Komfort mit unserem Online-Buchungstool. Egal ob tagsüber oder nachts, Sie können rund um die Uhr und von überall aus Termine vereinbaren - mit Ihrem Smart Device und einer Internetverbindung. Außerdem erhalten Sie Zugang zu Sonderangeboten wie Rabatten und exklusiven Happy-Hour-Aktionen. Übernehmen Sie die Kontrolle über Ihre Termine und genießen Sie die Vorteile einer nahtlosen Online-Buchung!",
      "any-time-title": "24/7 online buchen",
      "any-time-description": "Buche rund um die Uhr, ganz ohne Stress",
      "any-where-title": "Buchungen ohne Grenzen",
      "any-where-description": "Egal ob du zu Hause, unterwegs oder im Ausland bist",
      "discount-title": "Beste Deals",
      "discount-description": "Sichere dir jetzt tolle Rabatte und exklusive Happy-Hour-Angebote"
    }
  }
}
